import { useEffect, useState } from "react";
import { requireSupabase } from "@/lib/supabase";

/**
 * Resolve a human-readable org name from an org UUID.
 * Returns null when no org id is provided or lookup fails.
 */
export function useOrganizationName(orgId: string | null | undefined): string | null {
  const [name, setName] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    const trimmed = typeof orgId === "string" ? orgId.trim() : "";
    if (!trimmed) {
      setName(null);
      return;
    }

    void (async () => {
      try {
        const sb = requireSupabase();
        const { data } = await sb.from("organizations").select("name").eq("id", trimmed).maybeSingle();
        if (cancelled) return;
        const resolved = typeof data?.name === "string" ? data.name.trim() : "";
        setName(resolved || null);
      } catch {
        if (!cancelled) setName(null);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [orgId]);

  return name;
}
